module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center page"
  }, [(_vm.unifiedorder && _vm.unifiedorder.product) ? _c('div', [_c('div', {
    staticClass: "item"
  }, [_c('h2', [_vm._v(_vm._s(_vm.unifiedorder.product.name))]), _vm._v(" "), _c('div', {
    staticClass: "image-wrapper"
  }, [_c('img', {
    attrs: {
      "src": _vm.weixinIcon,
      "width": "100px",
      "height": "100px"
    }
  })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.unifiedorder.product.description))]), _vm._v(" "), _c('p', [_vm._v("支付金额: "), _c('strong', {
    staticClass: "money"
  }, [_vm._v("¥ " + _vm._s(_vm._f("currency")(_vm.unifiedorder.product.price)) + " 元")])]), _vm._v(" "), _c('p', {
    staticClass: "linear"
  }), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "item-btn",
    attrs: {
      "href": _vm.unifiedorder.url
    }
  }, [_vm._v("立即购买")])])])]) : _c('div', {
    staticClass: "loading-text"
  }, [_vm._v("正在加载...")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-792e31c3","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/web/wechat/product.vue
// module id = DtDI
// module chunks = 3